import React from 'react';
import PropTypes from 'prop-types';
import { Table, Dropdown, Icon } from 'semantic-ui-react';
import { AuctionSystem } from '../../utilities/commonData';

export const LocationInfoAction = {
  EDIT: 'Edit Auction',
  CONTACTS: 'Contacts',
  ADDITIONAL_DETAIL: 'Additional details',
  INELIGIBLE_LANES: 'Ineligible Lanes',
  START_AND_END_DATE: 'Start and end dates',
};

const SelectableItem = ({
  value, text, disabled, onSelectAction,
}) => {
  return (
    <Dropdown.Item
      text={text}
      value={value}
      onClick={disabled ? undefined : (e, data) => onSelectAction(e, data)}
      style={disabled ? { color: 'gray', pointerEvents: 'none', opacity: 0.5 } : {}}
    />
  );
};

SelectableItem.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onSelectAction: PropTypes.func.isRequired,
};

SelectableItem.defaultProps = {
  disabled: false,
};

const LocationListRow = ({ location, actionHandler, isAuctionLocationEditor }) => {
  const onSelectAction = (e, data) => {
    e.preventDefault();
    const action = data.value;
    actionHandler(location, action);
  };

  const statusIcon = truthly => {
    if (truthly) {
      return <Icon color='green' name='checkmark' size='large' />;
    }
    return <Icon color='red' name='close' size='large' />;
  };

  const address = (street, city, state, zip) => {
    return `${street || ''} ${city || ''} ${state || ''} ${zip || ''}`.trim();
  };

  const saleDaysDisplayVal = () => {
    if (location && location.saleDays) {
      return location.saleDays.split(',').join(', ');
    }
    return '';
  };

  const getAuctionSystemText = auctionSystemValue => {
    if (!auctionSystemValue) return '';

    const found = AuctionSystem.find(option => option.value === auctionSystemValue);
    return found ? found.text : auctionSystemValue;
  };

  const renderEmailsCell = emails => {
    const baseClasses = ['space-pre-wrap', 'word-break-word'];
    if (emails) baseClasses.push('email-cell');
    return (
      <Table.Cell className={baseClasses.join(' ')}>
        {emails || ''}
      </Table.Cell>
    );
  };
  return (
    <Table.Row>
      <Table.Cell>
        <div className='space-pre-wrap word-break-word width-limit'>
          {location.locationName || ''}
        </div>
      </Table.Cell>
      <Table.Cell className='space-pre-wrap'>
        {location.locationCode || ''}
      </Table.Cell>
      <Table.Cell>{location.auctionedgeCode || ''}</Table.Cell>
      <Table.Cell>{getAuctionSystemText(location.auctionSystem)}</Table.Cell>
      <Table.Cell>
        <div className='text-center'>
          {statusIcon(location.purchaseEnabled)}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>{statusIcon(location.acceptsReturns)}</div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>
          {statusIcon(location.inspectionsEnabled)}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>
          {statusIcon(location.dsPaidPsiEnabled)}
        </div>
      </Table.Cell>
      <Table.Cell>{location.titleAllowanceDays}</Table.Cell>
      <Table.Cell className='space-pre-wrap word-break-word'>
        {saleDaysDisplayVal()}
      </Table.Cell>
      <Table.Cell>{location.supplierNumber || ''}</Table.Cell>
      <Table.Cell className='space-pre-wrap word-break-word width-limit'>
        {location.macolaInventoryCode || ''}
      </Table.Cell>
      <Table.Cell className='space-pre-wrap'>
        {address(
          location.locationStreet,
          location.locationCity,
          location.locationState,
          location.locationZip
        )}
      </Table.Cell>
      <Table.Cell>{location.returnInstructions || ''}</Table.Cell>
      {renderEmailsCell(location.returnEmails)}
      {renderEmailsCell(location.externalAuctionEmails)}
      {renderEmailsCell(location.additionalEmails)}
      <Table.Cell>
        <Dropdown
          text='Actions'
          inline
          item
          icon='ellipsis horizontal'
          direction='left'
        >
          <Dropdown.Menu>
            <SelectableItem
              text={LocationInfoAction.EDIT}
              value={LocationInfoAction.EDIT}
              disabled={!isAuctionLocationEditor}
              onSelectAction={onSelectAction}
            />
            <SelectableItem
              text={LocationInfoAction.CONTACTS}
              value={LocationInfoAction.CONTACTS}
              onSelectAction={onSelectAction}
            />
            <SelectableItem
              text={LocationInfoAction.ADDITIONAL_DETAIL}
              value={LocationInfoAction.ADDITIONAL_DETAIL}
              onSelectAction={onSelectAction}
            />
          </Dropdown.Menu>
        </Dropdown>
      </Table.Cell>
    </Table.Row>
  );
};

LocationListRow.propTypes = {
  location: PropTypes.shape({
    locationName: PropTypes.string,
    locationCode: PropTypes.string,
    auctionedgeCode: PropTypes.string,
    auctionSystem: PropTypes.string,
    purchaseEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    acceptsReturns: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    inspectionsEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    dsPaidPsiEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    titleAllowanceDays: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    saleDays: PropTypes.string,
    supplierNumber: PropTypes.string,
    macolaInventoryCode: PropTypes.string,
    locationStreet: PropTypes.string,
    locationCity: PropTypes.string,
    locationState: PropTypes.string,
    locationZip: PropTypes.string,
    returnInstructions: PropTypes.string,
    returnEmails: PropTypes.string,
    externalAuctionEmails: PropTypes.string,
    additionalEmails: PropTypes.string,
  }).isRequired,
  actionHandler: PropTypes.func.isRequired,
  isAuctionLocationEditor: PropTypes.bool.isRequired,
};

export default LocationListRow;
